import { useEffect } from 'react';
import { useStore, StoreTypes } from 'context';
import { setUserRole } from 'util/ga';

export const useGAUserRole = () => {
  const [{ isLogin, role }] = useStore(StoreTypes.user);
  useEffect(() => {
    setUserRole(isLogin ? (role || 'student') : 'guest');
  }, [isLogin, role]);
};
